import { useLoad } from "@allergy123/api-client/react";
import { Card, Status, Table, Td, Th } from "@allergy123/ui";
import { Link } from "react-router";

const records = [
  ["completions", "Content completion"],
  ["knowledgeResults", "Knowledge result"],
  ["practicalEvidence", "Practical evidence"],
  ["eligibility", "Recognition eligibility"],
  ["recognitions", "Recognition issued"],
] as const;

/** Learner progress shows the five records separately and never collapses them into one "certified" state (ADR 0011). */
export function LearnersPage() {
  const data = useLoad((a) => a.admin.learners());
  return (
    <>
      <h1 className="mb-2 text-h1 font-semibold text-anchor">Learners</h1>
      <p className="mb-8 max-w-[68ch] text-ink-secondary">Every person with a platform account, the practices they belong to, and a count for each of the five records. None of the five implies the next.</p>
      {data.state === "error" && <Status kind="error" label={`Couldn't load learners (${data.error?.message})`} />}
      <Card>
        <Table caption={data.data ? `${data.data.learners.length} account${data.data.learners.length === 1 ? "" : "s"}` : "Loading…"}>
          <thead>
            <tr>
              <Th>Person</Th>
              <Th>Practices</Th>
              {records.map(([k, label]) => (
                <Th key={k} className="text-right">
                  {label}
                </Th>
              ))}
              <Th>Last activity</Th>
            </tr>
          </thead>
          <tbody>
            {data.data?.learners.map((l) => (
              <tr key={l.userId}>
                <Td>
                  <Link to={`/learners/${l.userId}`} className="font-medium">
                    {l.name ?? l.email}
                  </Link>
                  <div className="text-small text-ink-secondary">{l.email}</div>
                </Td>
                <Td>{l.organizations.length ? l.organizations.map((o) => `${o.name} (${o.role})`).join(", ") : <span className="text-ink-secondary">Individual</span>}</Td>
                {records.map(([k]) => (
                  <Td key={k} className="text-right tabular-nums">
                    {l.records[k]}
                  </Td>
                ))}
                <Td className="whitespace-nowrap">{l.lastSeenAt ? new Date(l.lastSeenAt).toLocaleDateString() : "—"}</Td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </>
  );
}
